import { useEffect, useState } from "react";
import { api, errMsg, fmtDate } from "../../api";
import { Input, Notice, PageHead } from "../../components/ui";

interface E { id: number; at: string; action: string; realm: string | null; tenantId: string | null; actorUserId: string | null; ip: string | null; details: Record<string, unknown> }

export function Audit() {
  const [action, setAction] = useState("");
  const [items, setItems] = useState<E[]>([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    const t = setTimeout(() => {
      const q = new URLSearchParams({ limit: "100" });
      if (action) q.set("action", action);
      api<{ items: E[] }>("GET", `/api/admin/audit?${q}`).then((r) => { setItems(r.items); setErr(""); }).catch((e) => setErr(errMsg(e)));
    }, 200);
    return () => clearTimeout(t);
  }, [action]);
  return (
    <>
      <PageHead title="Auditoria" sub="Trilha append-only de autenticação e ações administrativas. Senhas e códigos nunca são registrados." />
      <div className="toolbar"><Input placeholder="Filtrar por ação (ex.: auth.login, admin.)" value={action} onChange={(e) => setAction(e.target.value)} aria-label="Filtrar ação" /></div>
      {err && <Notice kind="error">{err}</Notice>}
      <div className="card" style={{ padding: 0, overflowX: "auto" }}>
        <table>
          <thead><tr><th>Quando</th><th>Ação</th><th>Realm</th><th>IP</th><th>Detalhes</th></tr></thead>
          <tbody>
            {items.map((e) => (
              <tr key={e.id}>
                <td>{fmtDate(e.at)}</td><td className="tabular">{e.action}</td><td>{e.realm ?? "—"}</td><td className="tabular">{e.ip ?? "—"}</td>
                <td className="tabular" style={{ fontSize: 12, color: "var(--text-muted)" }}>{Object.keys(e.details).length ? JSON.stringify(e.details) : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
